<ion-chip color="dark">
  <ion-icon src="/assets/images/icon-hammer.svg"></ion-icon>
  <strong>{{ hammerRating ?? 'N/A' }}</strong>
</ion-chip>
